<template>
  <div class="no-cover">
    <SvgIcon class="icon-picture" :className="className" iconClass="picture"></SvgIcon>
    <slot></slot>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon";
export default {
  props: {
    className: String
  },
  components: { SvgIcon },
};
</script>

<style lang="scss" scoped>
.no-cover {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 14px;
  .icon-picture {
    font-size: 23px;
    margin-bottom: 8px;
  }
}
</style>